<div class="notes-preview-container">
  <div class="preview-header">
    <span class="note-type-title">{{ getNoteTypeTitle() }}</span>
  </div>
  
  <div class="preview-content" *ngIf="notes && notes.length > 0">
    <div *ngFor="let note of getSortedNotes().slice(0, 3); let i = index" class="note-preview-item">
      <div *ngIf="shouldShowDateSeparator(note, i)" class="date-separator">
        <span class="date-text">{{ getDateDisplayText(note.createdDate) }}</span>
      </div>
      
      <!-- Note Preview -->
      <div class="note-content">
        <div class="note-date">{{ note.createdDate+'Z' | date: countryData.AngularDateFormat + ' h:mm a' }}</div>
        <div class="note-text">{{ note.note | slice:0:200 }}{{ note.note.length > 200 ? '...' : '' }}</div>
      </div>
    </div>
    
    <div class="more-notes" *ngIf="notes.length > 3">
      <span>{{ 'bikeshop.modal.update_job_card.job_card.live_updates.notes_preview.x_more_notes' | translate: { count: notes.length - 3 } }}</span>
    </div>
  </div>
  
  <div class="no-notes-preview" *ngIf="!notes || notes.length === 0">
    <span>{{ 'bikeshop.modal.update_job_card.job_card.live_updates.notes_preview.no_notes' | translate }}</span>
  </div>
</div>
